import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@repo/common/utils/cn";
import { _BODY_BASE } from "./text";
const labelVariants = cva([_BODY_BASE, "leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-foreground"], {
  variants: {
    weight: {
      normal: "font-normal",
      medium: "font-medium"
    }
  },
  defaultVariants: {
    weight: "normal"
  }
});
const Label = t0 => {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      weight: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const weight = t1 === undefined ? "normal" as const : t1;
  let t2;
  if ($[4] !== className || $[5] !== weight) {
    t2 = cn(labelVariants({
      weight,
      className
    }));
    $[4] = className;
    $[5] = weight;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props || $[8] !== t2) {
    t3 = <LabelPrimitive.Root data-slot="label" className={t2} {...props} />;
    $[7] = props;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
Label.displayName = LabelPrimitive.Root.displayName;
export { Label, labelVariants };

// Audit

// when used with a single input field no description or error message
// sm / normal

// when used with as part of a form field (support description and/or error message)
// sm / medium